/* global ROOT */

export default {
    namespaced: true,

    state: () => ({
        data: {}, // see bridge._fetchCache()

        voiceOptions: { // All the current Voice selections made in the buyflow
            serviceAndOptions: { // The Voice service selection (Unlimited Voice Service, Phone interest) and options selection (Port/Transfer number, Host New number) or null
                decision: null,
                selection: [],
            },
            declined: false, // The voice service declined selection
        },
    }),

    getters: {
        hasSelected: (state) => (minLength = 1) => {
            // returns true if the user has selected at least one item or the specified minlength, false otherwise
            return state.voiceOptions.serviceAndOptions.selection.length >= minLength
        },
        isSelected: (state, getters) => (item, type = 1) => {
            // returns true if the item is selected, false otherwise
            const serviceAndOptions = state.voiceOptions.serviceAndOptions.selection
            return getters.hasSelected(type) && serviceAndOptions.findIndex(s => s.name === item.name) > -1
        },
        getServicePrice: (state) => (service) => {
            // returns the price of the service
            if (state.data?.credits && state.data?.credits[0]) {
                return service.price + state.data?.credits.reduce((acc, credit) => acc += credit.price, 0)
            }

            return service.price
        },
        isHidden (state, getters, rootState, rootGetters) {
            // returns true if the Voice section should be hidden, otherwise false
            return rootGetters['Buyflow/buyflowFeature']('buyflow_hide', 'voice')
        },
        isMinimal (state, getters, rootState, rootGetters) {
            // returns true if the Voice section should be minimal, otherwise false
            return rootGetters['Buyflow/buyflowFeature']('buyflow_minimal', 'voice')
        },
    },

    mutations: {
        UPDATE_VOICE_OPTIONS (state, decision) {
            state.voiceOptions = {...state.voiceOptions, ...decision }
        }
    },

    actions: {
        init({ commit, state, rootState}) {
            const voice = rootState.Buyflow.receipt.cartData?.services?.voice
            const base = rootState.Buyflow.receipt.cartData?.services?.voice?.base
            const service = voice?.length? Object.values(state.data?.services || {}).find(o => o.name === voice[0].name)?? {}: {}
            const option  = base?.length? Object.values(state.data?.portOptions || {}).find(o => o.title === base[0].name) ?? {}: {}
            const selection = [
                {...service},
                {...option}
            ].filter((o) => Object.keys(o).length !== 0)

            commit('UPDATE_VOICE_OPTIONS', {
                serviceAndOptions: {
                    decision: service?.decision ?? null,
                    selection: selection,
                },
            })
        },
        setVoiceOptions ({ dispatch, commit, state, getters, rootGetters, rootState }, payload) {
            // If the location is ohio and there is a voice selection and the use currently has self install then we need to change the install type to pro install
            if (rootGetters['Buyflow/isOhio'] && payload?.service?.selection?.length && rootGetters['Buyflow/finalize/hasSelectedSelfInstall']) {
                dispatch('Buyflow/finalize/submitInstallationFulfillment', rootState.Buyflow.finalize.installData?.proInstall, ROOT)
            }
            commit('UPDATE_VOICE_OPTIONS', payload)
            return dispatch('Buyflow/updateDecisions', payload, ROOT)
        },
        declineService ({ dispatch, state, rootGetters, rootState }) {
            dispatch('setVoiceOptions', {
                serviceAndOptions: {
                    decision: state.voiceOptions.serviceAndOptions.decision,
                    selection: [],
                },
                declined: true,
            })

            // If the location is Ohio and the user currently has pro install and they are eligible for self install then we need to change the install type back to self install
            if (rootGetters['Buyflow/isOhio'] && !rootGetters['isPendingDisconnect'] && rootState.Buyflow.finalize.installData?.selfInstallKit && !rootGetters['Buyflow/finalize/hasSelectedSelfInstall']) {
                dispatch('Buyflow/finalize/submitInstallationFulfillment', rootState.Buyflow.finalize.installData?.selfInstallKit, ROOT)
            }
        },
    },
}
